var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.53125 12.4688C6.29688 12.2344 6.29688 11.8047 6.53125 11.5703L14.0312 4.07031C14.2656 3.83594 14.6953 3.83594 14.9297 4.07031C15.1641 4.30469 15.1641 4.73438 14.9297 4.96875L7.85938 12L14.9297 19.0703C15.1641 19.3047 15.1641 19.7344 14.9297 19.9688C14.6953 20.2031 14.2656 20.2031 14.0312 19.9688L6.53125 12.4688Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeft);
export default __webpack_public_path__ + "static/media/left.b67fd8cdd879e8a0265109f0136fa95a.svg";
export { ForwardRef as ReactComponent };